import { currencyFormatter } from "@/Utils/Currency";
import {
	displayPricingName,
	ratailPriceLabel
} from "@/Contracts/Products";
import { ZTypography, ZSelect } from "@atoms/index";
import { EFontWeights } from "@atoms/ZTypography/interface";
import { Row, Col, Radio } from "antd";
import Checkbox from "antd/lib/checkbox";
import { DistributorPricingRadioProps } from "./interface";
import React from "react";

const { ZText } = ZTypography;

const DistributorPricingOption: React.FC<DistributorPricingRadioProps> = ({
	pricing,
	selectedWarehouse,
	onWarehouseChange,
	hideWarehouseOptions,
	isAutoUpdatePricingEnabled,
	selectedDistributors,
	handlePricingsChange,
	isReadOnly = false,
	currencyCode
}: DistributorPricingRadioProps) => {
	const currencySettings = currencyCode ? { currency: currencyCode } : undefined;
	const distributorPricingDetails = pricing?.distributor_pricing_details;
	const stockLevel = distributorPricingDetails
		? `${distributorPricingDetails.total_availability}/${distributorPricingDetails.total_on_order}`
		: "NA";

	const selectOptions =
		(pricing &&
			distributorPricingDetails?.branch_wise_details?.map(warehouse => ({
				name: `${warehouse.branch_name} (${warehouse.availability}/${warehouse.on_order})`,
				value: warehouse.branch_name
			}))) ??
		[];

	const warehouse =
		distributorPricingDetails?.distributor &&
		!!selectedDistributors?.length &&
		!!selectedWarehouse?.length &&
		[
			...selectedDistributors.map(distributor => distributor.distributor)
		].includes(distributorPricingDetails?.distributor)
			? selectedWarehouse
			: selectOptions[0]?.value;

	const retailPriceInfo =
		distributorPricingDetails?.distributor &&
		distributorPricingDetails?.retail_price
			? `${
					ratailPriceLabel[distributorPricingDetails?.distributor]
			  }: ${currencyFormatter(
					distributorPricingDetails?.retail_price,
					"",
					undefined,
					currencySettings
			  )}`
			: "";

	return (
		<Row className="product-distributor-control py-2">
			<Col span={12}>
				{!isAutoUpdatePricingEnabled ? (
					<Radio
						value={pricing.id}
						data-testid={`test-pricing-id-${pricing.id}`}
						disabled={isReadOnly}
					>
						<ZText
							weight={EFontWeights.MEDIUM}
							className="text-gray-8"
						>
							{displayPricingName(pricing)}
						</ZText>
						{" | "}
						<ZText className="text-gray-8">
							{pricing.cost_price !== null
								? `${currencyFormatter(
										pricing.cost_price,
										"",
										undefined,
										currencySettings
								  )}`
								: "NA"}
						</ZText>
						<br />
						<ZText className="text-gray-8">{`Stock Level: ${stockLevel}`}</ZText>
						<br />
						{retailPriceInfo && (
							<ZText className="text-gray-7">
								{retailPriceInfo}
							</ZText>
						)}
					</Radio>
				) : (
					<Checkbox
						value={pricing.id}
						data-testid={`test-pricing-id-${pricing.id}`}
						onChange={handlePricingsChange}
						disabled={isReadOnly}
					>
						<ZText
							weight={EFontWeights.MEDIUM}
							className="text-gray-8"
						>
							{displayPricingName(pricing)}
						</ZText>
						{" | "}
						<ZText className="text-gray-8">
							{pricing.cost_price !== null
								? `${currencyFormatter(
										pricing.cost_price,
										"",
										undefined,
										currencySettings
								  )}`
								: "NA"}
						</ZText>
						<br />
						<ZText className="text-gray-8">{`Stock Level: ${stockLevel}`}</ZText>
						<br />
						{retailPriceInfo && (
							<ZText className="text-gray-7">
								{retailPriceInfo}
							</ZText>
						)}
					</Checkbox>
				)}
			</Col>
			<Col span={12}>
				{distributorPricingDetails?.branch_wise_details &&
					!hideWarehouseOptions && (
						<ZSelect
							onChange={(value: string) => {
								onWarehouseChange(pricing, value);
							}}
							value={warehouse}
							selectOptions={selectOptions}
							disabled={isReadOnly}
						/>
					)}
			</Col>
		</Row>
	);
};

export default DistributorPricingOption;
